import { BillableItemSummary } from "../types/billableItemAssignment";

export const BILLABLE_ITEMS_PAGE_SIZE = 50;

interface BillableItemsPageResult {
  data?: {
    billableItemsPaginated?: {
      edges: { node: BillableItemSummary }[];
      pageInfo: { hasNextPage: boolean };
    } | null;
  } | null;
}

type FetchBillableItemsPage = (variables: {
  courierId: string;
  endCustomerIdFilter: string;
  after: number;
  limit: number;
}) => Promise<BillableItemsPageResult>;

/**
 * Walks every page of billableItemsPaginated for one end customer, so the picker never
 * silently truncates. The backend does the customer filtering, so this usually completes
 * in a single page. Takes the fetcher as a parameter to stay independent of Apollo.
 */
export function fetchAllBillableItemPages(
  fetchPage: FetchBillableItemsPage,
  courierId: string,
  endCustomerIdFilter: string,
  after: number = 0,
  accumulated: BillableItemSummary[] = []
): Promise<BillableItemSummary[]> {
  return fetchPage({
    courierId,
    endCustomerIdFilter,
    after,
    limit: BILLABLE_ITEMS_PAGE_SIZE,
  }).then((page) => {
    const connection = page.data?.billableItemsPaginated;
    const billableItems = [
      ...accumulated,
      ...(connection?.edges ?? []).map((edge) => edge.node),
    ];
    if (!connection?.pageInfo?.hasNextPage) return billableItems;
    return fetchAllBillableItemPages(
      fetchPage,
      courierId,
      endCustomerIdFilter,
      after + BILLABLE_ITEMS_PAGE_SIZE,
      billableItems
    );
  });
}
